import React from "react";

export function SingleStat(props) {
    return (
        <div 
            className={`tooltip-container ${props.className || ''}`}
            title={props.tooltip || `${props.name}: ${props.value}`}
            style={{ 
                position: 'relative',
                display: 'inline-block',
                cursor: props.tooltip ? 'help' : 'default'
            }}
        >
            <p className={props.className}>{props.name} : {props.value}</p>
        </div>
    );
}
